module.exports = __webpack_public_path__ + "static/logo_oxton-1438233e4b9b909916c469f9b6b5e3f7.png";